import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { PaymentMethods } from './PaymentMethods';
import { ShieldCheck, Clock } from 'lucide-react';
export function Pricing() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 43,
    seconds: 53
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) return {
          ...prev,
          seconds: prev.seconds - 1
        };
        if (prev.minutes > 0) return {
          ...prev,
          minutes: prev.minutes - 1,
          seconds: 59
        };
        if (prev.hours > 0) return {
          hours: prev.hours - 1,
          minutes: 59,
          seconds: 59
        };
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <section id="pricing" className="py-16 md:py-24 bg-ballet-100 relative overflow-hidden" data-id="element-163">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-164">
        <div className="text-center mb-10 md:mb-12" data-id="element-165">
          <div className="inline-flex items-center justify-center bg-red-100 text-red-700 px-4 py-2 rounded-full font-bold text-xs md:text-sm mb-4 md:mb-6 animate-pulse" data-id="element-166">
            <Clock className="w-4 h-4 mr-2" data-id="element-167" />
            OFFERTA DI LANCIO — IL PREZZO AUMENTA TRA
          </div>
          <p className="text-sm md:text-base text-gray-600 mb-4 md:mb-6" data-id="element-168">
            E non tornerà a scendere
          </p>

          <div className="flex justify-center gap-4 text-3xl md:text-5xl font-bold font-serif text-charcoal" data-id="element-169">
            <div className="bg-white px-4 py-3 rounded-xl shadow-sm min-w-[80px]" data-id="element-170">
              {String(timeLeft.hours).padStart(2, '0')}
              <div className="text-xs font-sans font-normal text-gray-400 mt-1 uppercase" data-id="element-171">
                Ore
              </div>
            </div>
            <span className="py-3" data-id="element-172">:</span>
            <div className="bg-white px-4 py-3 rounded-xl shadow-sm min-w-[80px]" data-id="element-173">
              {String(timeLeft.minutes).padStart(2, '0')}
              <div className="text-xs font-sans font-normal text-gray-400 mt-1 uppercase" data-id="element-174">
                Min
              </div>
            </div>
            <span className="py-3" data-id="element-175">:</span>
            <div className="bg-white px-4 py-3 rounded-xl shadow-sm min-w-[80px]" data-id="element-176">
              {String(timeLeft.seconds).padStart(2, '0')}
              <div className="text-xs font-sans font-normal text-gray-400 mt-1 uppercase" data-id="element-177">
                Sec
              </div>
            </div>
          </div>

          <div className="mt-8 max-w-xs mx-auto" data-id="element-178">
            <div className="flex justify-between text-xs text-gray-500 mb-1 font-medium" data-id="element-179">
              <span data-id="element-180">Posti rimanenti</span>
              <span data-id="element-181">68% GIÀ PRESI</span>
            </div>
            <div className="w-full bg-gray-200 rounded-full h-2.5" data-id="element-182">
              <div className="bg-ballet-500 h-2.5 rounded-full" style={{
              width: '68%'
            }} data-id="element-183"></div>
            </div>
          </div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white rounded-3xl shadow-xl border-2 border-ballet-200 p-6 md:p-12 text-center relative max-w-2xl mx-auto transition-transform duration-300 hover:-translate-y-2" data-id="element-184">
          <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-ballet-600 text-white px-4 md:px-6 py-1 md:py-1.5 rounded-full text-xs md:text-sm font-bold tracking-wider shadow-md" data-id="element-185">
            PIÙ SCELTO
          </div>

          <h3 className="text-xl md:text-2xl font-bold text-charcoal mb-2 mt-2 md:mt-0" data-id="element-186">
            🩰 BALLET PRONTO™
          </h3>
          <p className="text-sm md:text-base text-ballet-600 font-medium mb-6 md:mb-8" data-id="element-187">
            7 Volumi + 5 Bonus Strategici Gratuiti
          </p>

          <div className="flex justify-center items-center gap-3 md:gap-4 mb-6 md:mb-8" data-id="element-188">
            <span className="text-2xl md:text-3xl text-gray-400 line-through decoration-red-400 decoration-2" data-id="element-189">
              €97
            </span>
            <span className="text-5xl md:text-6xl font-bold text-charcoal" data-id="element-190">
              €27
            </span>
          </div>

          <Button onClick={() => window.location.href = 'https://ballet-pronto.impultienda.ar/checkout'} fullWidth className="text-lg md:text-xl py-4 md:py-5 mb-5 shadow-ballet-300/50 shadow-xl" data-id="element-191">
            🚀 SÌ, VOGLIO IL MIO BALLET PRONTO™ ORA
          </Button>

          <PaymentMethods className="mb-6" data-id="element-192" />

          <div className="flex flex-wrap justify-center gap-3 md:gap-4 text-xs md:text-sm text-gray-600 font-medium" data-id="element-193">
            <div className="flex items-center" data-id="element-194">
              <ShieldCheck className="w-4 h-4 mr-1 text-green-600" data-id="element-195" />
              Pagamento Sicuro
            </div>
            <div className="flex items-center" data-id="element-196">
              <ShieldCheck className="w-4 h-4 mr-1 text-green-600" data-id="element-197" />
              Accesso in 5 minuti
            </div>
            <div className="flex items-center" data-id="element-198">
              <ShieldCheck className="w-4 h-4 mr-1 text-green-600" data-id="element-199" />
              Garanzia 7 giorni
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}